import { render } from "./Vraag.vue?vue&type=template&id=2d2eb9c8&scoped=true"
import script from "./Vraag.vue?vue&type=script&lang=js"
export * from "./Vraag.vue?vue&type=script&lang=js"

import "./Vraag.vue?vue&type=style&index=0&id=2d2eb9c8&lang=scss&scoped=true"

import exportComponent from "C:\\websites\\kroechkwis-master\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d2eb9c8"]])

export default __exports__